import { useMutation } from 'react-query';
import { discardDraft, submitDraft, createDraft } from '~/api/draft';

export const draftIdPostfix = '.draft';

export const useCreateDraft = () => {
  return useMutation(createDraft);
};

export const useSubmitDraft = () => {
  return useMutation(submitDraft);
};

export const useDiscardDraft = () => {
  return useMutation(discardDraft);
};

export const removeDraftPostfix = (id: string) => {
  const hasDraftPostfix = id?.includes(draftIdPostfix);
  if (!hasDraftPostfix) {
    return id;
  }
  return id.replace(draftIdPostfix, '');
};
